module.exports = __webpack_public_path__ + "media/images/tw_ico-6b6fdafa8764811510bca123718ac655.png";